import { Pipe, PipeTransform } from '@angular/core';
import { CultureService } from '@app/modules/core/services/culture.service';

@Pipe({ name: 'formatNumber', standalone: true })
export class FormatNumberPipe implements PipeTransform {
  constructor(private cultureService: CultureService) {}

  transform(value: any, format: string): string {
    if (!value && value !== 0) {
      return '---';
    }

    if (!format) {
      format = 'NUMBER';
    }

    return this.cultureService.getNumberDisplay(value, format);
  }
}
